function TabButton({ id, optionName, selected, handleSelect }) {
    const handleButtonClick = () => {
        handleSelect(id);
    }

    return (
        <div className="flex flex-col mb-[-3px]">
            <button id={id} onClick={handleButtonClick} className={`${selected === id ? 'text-[#121212] font-semibold' : 'text-[#999999] font-medium'} select-none outline-none border-none p-[10px] pb-3 flex flex-col items-center text-sm text-center`}>
                {optionName}
            </button>

            {selected === id && <div className="h-1 rounded-[23px] bg-primaryColor"></div>}
        </div>
    );
}

export default TabButton;
